export default __webpack_public_path__ + "static/goldpiercingdust-6d408652c1c255174082fb9ebc6f267b.png";